import React from "react";

export const ComboBox1099 = ({ years, setYear }) => {
	const yearChangeEvent = (event) => {
		setYear(event.target.value);
	};

	return (
		<select onChange={yearChangeEvent}>
			{years.map((year, key) => <option value={year} key={key}>{year}</option>)}
		</select >
	);
};